"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELETE_TRAINING_POINT_CLOUD = void 0;
var client_1 = require("@apollo/client");
exports.DELETE_TRAINING_POINT_CLOUD = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation DeleteTrainingPointCloud($pointCloudId: ID!) {\n    deleteTrainingPointCloud(pointCloudId: $pointCloudId) {\n      deleted\n    }\n  }\n"], ["\n  mutation DeleteTrainingPointCloud($pointCloudId: ID!) {\n    deleteTrainingPointCloud(pointCloudId: $pointCloudId) {\n      deleted\n    }\n  }\n"])));
var templateObject_1;
